import { ArchiveLockOutlineIcon } from './ArchiveLockOutlineIcon';

/**
 * author: Colton Wiscombe
 * id E5F9A56B-CB7E-4EEC-B03A-571F9704E32E
 * name archive-lock-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-lock-outline.svg
 * tags
 * - Lock 
 */
export const BoxLockOutlineIcon = ArchiveLockOutlineIcon;
export default BoxLockOutlineIcon